import { Link } from 'gatsby';
import React, { useState } from 'react';
import styled from 'styled-components';

import ArrowDown from '../../icons/arrow-down.svg';

const MobileLinkGroup = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleGroup = () => {
    setIsOpen(!isOpen);
  };

  const { label, children, to } = props;

  if (to) {
    return (
      <Wrapper>
        <Label to={to} as={Link}>
          {label}
        </Label>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Label onClick={toggleGroup}>
        {label} <StyledArrowDown isOpen={isOpen} />
      </Label>
      <Links isOpen={isOpen}>{children}</Links>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const CleanStyledArrowDown = ({ isOpen, ...rest }) => <ArrowDown {...rest} />; // eslint-disable-line

const StyledArrowDown = styled(CleanStyledArrowDown)`
  margin-left: 10px;
  transition: all 0.2s linear;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const Label = styled.button`
  background: none;
  appearance: none;
  cursor: pointer;
  text-decoration: none;
  border: none;
  padding: 0;
  font-size: var(--heading-size-xs);
  color: var(--white);

  display: flex;
  align-items: center;
  margin-bottom: 20px;

  &:focus {
    outline: none;

    ${StyledArrowDown} g {
      fill: #fff;
    }
  }
`;

const Links = styled.div`
  transition: all 0.2s linear;
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0px')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
`;

export default MobileLinkGroup;
